import styled from "styled-components";

// Components
import Text from "../Text";
import StripeExpressCheckout from "../checkout/StripeExpressCheckout";
// Utils
import { Icons } from "../../utils/react-svg";
import ElementsWrapper from "../checkout/ElementsWrapper";
import { useSelector } from "react-redux";
import promotionSelectors from "../../store/promotion/selectors";
import { useState } from "react";

const BottomCheckoutButtonContainer = styled.div`
  width: 100%;
  border-top: 1px solid var(--cool-40);
  padding: var(--spacing-1) var(--spacing-1_5)
    calc(var(--spacing-1) + env(safe-area-inset-bottom));

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: var(--spacing-0_5);
`;

const BottomReactCheckoutButton = styled.button`
  display: flex;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 25px;
  border: none;
  background: var(--indigo-blue);
  color: var(--white);
  height: 48px;
  transition:
    background 0.2s,
    color 0.2s;
  font-size: 16px;
  line-height: 24px;

  // Set min-width to share space with Apple Pay when present
  min-width: calc(50% - var(--spacing-0_25));
  width: 100%;

  svg {
    path,
    rect {
      transition: stroke 0.2s;
    }
  }

  &:hover {
    background: var(--yellow-ochre);
    color: var(--indigo-blue);

    svg {
      path,
      rect {
        stroke: var(--indigo-blue);
      }
    }
  }
`;

const ButtonCopy = styled.span.attrs({ className: "typography-label1" })`
  font-size: var(--spacing-1, 16px) !important;
`;

export default function FlyoutCartBottom({
  activeCart,
  isAddingToSubscription,
  isProcessing,
  cartProducts,
  cartQuantity,
  activeCoupon,
  handleCheckoutCTAClicked,
  setExpressCheckoutProcessing,
}) {
  const appliedPromotion = useSelector(promotionSelectors.appliedPromotion);
  const [showErrorBanner, setShowErrorBanner] = useState(false);
  const canCheckout = !!(!isProcessing && cartQuantity);
  const expressCheckoutEligible =
    canCheckout && !isAddingToSubscription && activeCart.total > 0;

  return (
    <ElementsWrapper>
      <BottomCheckoutButtonContainer>
        {showErrorBanner && (
          <p>We encountered an error with your payment. Please try again.</p>
        )}
        {expressCheckoutEligible && (
          <StripeExpressCheckout
            cart={activeCart}
            cartProducts={cartProducts}
            setShowErrorBanner={setShowErrorBanner}
            supportedExpressCheckoutPaymentMethods="applePay"
            coupon={activeCoupon}
            appliedPromotion={appliedPromotion}
            setExpressCheckoutProcessing={setExpressCheckoutProcessing}
            location="flyout_cart"
            showPayAnotherWay={false}
          />
        )}
        <BottomReactCheckoutButton
          disabled={!canCheckout}
          className="fullwidth"
          onClick={handleCheckoutCTAClicked}
          aria-label="Checkout"
          aria-disabled={!canCheckout}
        >
          <Icons.CreditCard />
          <ButtonCopy>
            <Text
              id={"cart.flyout.button-checkout"}
              defaultMessage={"Checkout"}
            />
          </ButtonCopy>
        </BottomReactCheckoutButton>
      </BottomCheckoutButtonContainer>
    </ElementsWrapper>
  );
}
